import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function NFTPurchase() {
  return (
    <div className="container-fluid profileBox dashboardprofile">
      <Row>
        <Col lg={12}>
          <h1>Digital Artwork Purchase & IP License Agreement</h1>
        </Col>
      </Row>
    </div>
  );
}
